// extracted by mini-css-extract-plugin
export default {"heading":"nC-z","signin":"oC-z","signupBtn":"pC-z","disabled":"qC-z"};